/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoGenerateInvoiceInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type ShipmentFinanceActionCardMutationVariables = {
    input: infoGenerateInvoiceInput;
};
export type ShipmentFinanceActionCardMutationResponse = {
    readonly infoGenerateInvoice: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ShipmentFinanceActionCardMutation = {
    readonly response: ShipmentFinanceActionCardMutationResponse;
    readonly variables: ShipmentFinanceActionCardMutationVariables;
};



/*
mutation ShipmentFinanceActionCardMutation(
  $input: infoGenerateInvoiceInput!
) {
  infoGenerateInvoice(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoGenerateInvoicePayload",
    "kind": "LinkedField",
    "name": "infoGenerateInvoice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShipmentFinanceActionCardMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShipmentFinanceActionCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b4ceb672439d9c5adcace125146439c1",
    "id": null,
    "metadata": {},
    "name": "ShipmentFinanceActionCardMutation",
    "operationKind": "mutation",
    "text": "mutation ShipmentFinanceActionCardMutation(\n  $input: infoGenerateInvoiceInput!\n) {\n  infoGenerateInvoice(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bb52556b1fba03763542c3a2386132a0';
export default node;
